import { AppRoutes } from '@core/AppRoutes'
import dayjs from '@mobi/utils/date/extendedDayjs'
import { appHistory } from '@core/Utils/routing/history'
import { getEditAddressRoute } from '@mobi/account/Areas/ContactDetails/Utils'

/** @deprecated only used for tabtouch-core package dependency navigation */
export function navigateToRace(data: {
  id?: string
  fixtureId: string
  raceNumber: string
  date?: string
  fixtureDate: string
}) {
  const formattedDate = dayjs(data.date || data.fixtureDate).format('YYYY-MM-DD')
  const racePageRoute = `/tote/meetings/${data.id || data.fixtureId}/${data.raceNumber}?date=${formattedDate}`
  appHistory.push(racePageRoute)
}

/** @deprecated only used for tabtouch-core package dependency navigation */
export function navigateToContactDetailsEdit({
  isDesktop,
  betAccountHolderNumber,
}: {
  isDesktop?: boolean
  betAccountHolderNumber: number
}) {
  if (isDesktop) {
    window.location.href = `/account/mypreferences/contactdetailsedit/${betAccountHolderNumber}`
  } else {
    appHistory.push(getEditAddressRoute(betAccountHolderNumber.toString()))
  }
}

/** @deprecated only used for tabtouch-core package dependency navigation */
export function navigateToDepositLimitsEdit(data: { isDesktop?: boolean }) {
  const { isDesktop } = data
  if (isDesktop) {
    window.location.href = AppRoutes.DepositLimits
  } else {
    appHistory.push(AppRoutes.DepositLimits)
  }
}

/** @deprecated only used for tabtouch-core package dependency navigation */
export function navigateToLogout({ isDesktop }: { isDesktop: boolean }) {
  if (isDesktop) {
    window.location.href = '/account/logoff'
  } else {
    appHistory.push('/account/logout')
  }
}
